module.exports = __webpack_public_path__ + "img/ceramic-magenta.a02ef0ee.png";